export default __webpack_public_path__ + "static/media/tdBank.25f6910e.svg";